import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Dumbbell, Users, GraduationCap, Building2, Flag, Map } from "lucide-react";
import { loginTo } from "./data";

const CATS = [
  { label: "Facilities", desc: "Book grounds & courts", icon: Dumbbell, to: "/browse?cat=facilities", guest: true, tint: "bg-orange-50 text-orange-600" },
  { label: "Teams", desc: "Create or join a team", icon: Users, to: "/app/teams", tint: "bg-emerald-50 text-emerald-600" },
  { label: "Academies", desc: "Coaching & training", icon: GraduationCap, to: "/browse?cat=academies", guest: true, tint: "bg-sky-50 text-sky-600" },
  { label: "Institutions", desc: "Schools & colleges", icon: Building2, to: "/browse?cat=schools", guest: true, tint: "bg-violet-50 text-violet-600" },
  { label: "Events", desc: "Tournaments & meets", icon: Flag, to: "/browse?cat=events", guest: true, tint: "bg-rose-50 text-rose-600" },
  { label: "Sports Tourism", desc: "Trips & camps", icon: Map, to: "/browse?cat=tourism", guest: true, tint: "bg-amber-50 text-amber-600" },
];

export default function CategoryCards() {
  return (
    <section className="mx-auto max-w-7xl px-4 py-12 sm:px-6">
      <h2 className="font-display text-2xl font-bold tracking-tight sm:text-3xl">Explore by category</h2>
      <p className="mt-2 text-sm text-muted-foreground">Everything you need across the SPORA1 sports ecosystem.</p>
      <div className="mt-6 grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-6">
        {CATS.map((c, i) => {
          const I = c.icon;
          return (
            <motion.div key={c.label} initial={{ opacity: 0, y: 12 }} whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }} transition={{ duration: 0.3, delay: i * 0.04 }}>
              <Link to={c.guest ? c.to : loginTo(c.to)} data-testid={`category-${c.label.toLowerCase().replace(/ /g, "-")}`}
                className="flex h-full flex-col items-center gap-2 rounded-2xl border border-border bg-card p-4 text-center transition-all hover:-translate-y-1 hover:border-primary/40 hover:shadow-lg">
                <span className={`flex h-12 w-12 items-center justify-center rounded-xl ${c.tint}`}>
                  <I className="h-6 w-6" />
                </span>
                <span className="font-display text-base font-semibold">{c.label}</span>
                <span className="text-xs text-muted-foreground">{c.desc}</span>
              </Link>
            </motion.div>
          );
        })}
      </div>
    </section>
  );
}
